import { useQuery } from '@tanstack/react-query';
import api from '../../api';
import useGlobalStore from '@/stores/global.store';
import { type Order } from '../../types/api/order/order';

type OrderQueryKey = ['orders', string];

export function useOrderQuery(orderId: string) {
  return useQuery<Order, Error, Order, OrderQueryKey>({
    queryKey: ['orders', orderId],
    queryFn: () => api.order.get(orderId),
    enabled: Boolean(orderId),
  });
}

export function useCurrentOrderQuery() {
  const orderId = useGlobalStore((state) => state.orderId);

  return useOrderQuery(orderId!);
}
